export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export function formatPageCount(pageIndex, pageSize, totalCount, suffix = '') {
    const from = pageIndex * pageSize - pageSize + 1;
    const to = Math.min(from + pageSize - 1, totalCount);
    const of = totalCount;
    return `Showing ${from} to ${to} of ${of} ${suffix}`.trim();
}
/**
 * Remove the specified property from the provided record.
 * @param value The object/record
 * @param key The string key to be removed
 * @returns A copy of the original object without the specified key.
 */
export function removeKey(value, key) {
    const copy = { ...value };
    delete copy[key];
    return copy;
}
export function clamp(value, max) {
    return Math.max(Math.min(value, max), 0);
}
